import { useEffect, useState } from "react";
import { AnalyticsDataResponse } from "@queries/Analytics";
import useAnalyticsData from "@hooks/analytics/useAnalyticsData";
import { ChartSkeleton } from "../../skeleton/ChartSkeleton";
import { ChartCardPresenter } from "./Presenter";
import { ChartCardBaseProps } from "./Interfaces";
import { defaultDataVehicleType } from "./PreviewData";

const ChartCardContainer = (props: ChartCardBaseProps) => {
  const {
    type,
    baseTime: { ...baseTime },
    options,
    onChangeInsightChat,
    isSingleLocation
  } = props;

  const [selected, setSelected] = useState<string[]>(defaultDataVehicleType);
  const [viewType, setViewType] = useState<string>(options?.viewList[0] ?? "");
  const [isLoadingChart, setIsLoadingChart] = useState<boolean>(true);
  const isAnalyticsType: Set<string> = new Set();

  const {
    analyticsDatas,
    dataSeries,
    isLoading,
    updatedAnalytics,
    categoryData,
    isCategoryDataLoading,
    updatedCategoryAnalytics,
    analyticsCSVDownload,
    timeInterval,
    typeInterval,
    setType
  } = useAnalyticsData(
    type,
    baseTime,
    viewType,
    props.rules,
    false,
    props.title,
    selected
  );

  useEffect(() => {
    if ((!baseTime?.start && !baseTime?.end) || !baseTime) return;
    if (!props.rules) return;
    if (!isAnalyticsType.has(props.title)) {
      setIsLoadingChart(true);
      setViewType(options?.viewList[0] ?? "");
      setSelected(defaultDataVehicleType);
      updatedAnalytics([], null, options?.viewList[0] ?? "", isSingleLocation);
      isAnalyticsType.add(props.title);
    }
  }, [JSON.stringify(baseTime), props.rules]);

  if (isLoading && isLoadingChart) {
    return <ChartSkeleton />;
  }

  return (
    <div>
      <ChartCardPresenter
        {...props}
        dataSeries={dataSeries}
        analyticsData={analyticsDatas as AnalyticsDataResponse[]}
        updatedAnalytics={updatedAnalytics}
        selected={selected}
        setSelected={setSelected}
        setViewType={setViewType}
        viewType={viewType}
        timeInterval={timeInterval}
        typeInterval={typeInterval}
        setType={setType}
        setInsightChat={onChangeInsightChat}
        widgetType={type}
        isLoading={isLoading}
        setIsLoadingChart={setIsLoadingChart}
        updatedCategoryAnalytics={updatedCategoryAnalytics}
        categoryData={categoryData}
        isCategoryDataLoading={isCategoryDataLoading}
        analyticsCSVDownload={analyticsCSVDownload}
      />
    </div>
  );
};

export default ChartCardContainer;
